import 'telia-front-react/styles/telia.css';
import 'telia-front-react/styles/global.css';
import './failures-map.scss';
import './tabs.scss';

import('bootstrap');
